import React from "react";

const FORMATS = [["portrait", "Phone · 4:5"], ["wide", "Wide · 16:9"]];

export function PostcardPreview({ postcard, format, setFormat, imageUrl, imgLoaded, setImgLoaded }) {
  return (
    <>
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="flex gap-1" data-testid="postcard-format-toggle">
          {FORMATS.map(([k, label]) => (
            <button
              key={k}
              type="button"
              onClick={() => { if (k !== format) { setImgLoaded(false); setFormat(k); } }}
              data-testid={`postcard-format-${k}`}
              className={`px-3 py-1 rounded-full border text-[10px] uppercase tracking-[0.2em] transition-colors ${format === k ? "border-[#C8A96E] bg-[#C8A96E]/15 text-[#C8A96E]" : "border-white/15 text-[#A89C98] hover:text-white"}`}
            >
              {label}
            </button>
          ))}
        </div>
        <span className="text-[10px] uppercase tracking-[0.2em] text-[#A89C98] hidden sm:inline">Photo of {postcard.city}</span>
      </div>
      <div
        className={`relative min-w-0 mx-auto rounded-xl overflow-hidden border border-[#C8A96E]/40 bg-black shadow-[0_0_40px_rgba(200,169,110,0.15)] ${format === "portrait" ? "w-full max-w-[300px] sm:max-w-[340px]" : "w-full"} ${imgLoaded ? "" : (format === "portrait" ? "min-h-[375px]" : "min-h-[180px]")}`}
        data-testid="postcard-preview"
      >
        {!imgLoaded && (
          <div className="absolute inset-0 flex items-center justify-center text-[10px] uppercase tracking-[0.3em] text-[#A89C98] animate-pulse" data-testid="postcard-image-loading">
            Developing photo…
          </div>
        )}
        <img
          key={imageUrl}
          src={imageUrl}
          alt="StarGrid postcard"
          onLoad={() => setImgLoaded(true)}
          className={`block w-full max-w-full h-auto transition-opacity duration-500 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
          data-testid="postcard-image"
        />
      </div>

    </>
  );
}
